import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMethodologyState } from './interfaces';

const initialState: IMethodologyState = {
  showedMethodologyCovers: {},
};

const methodologySlice = createSlice({
  name: 'methodology',
  initialState,
  reducers: {
    setShowedCover(state, action: PayloadAction<string>) {
      const { payload: coverId } = action;
      state.showedMethodologyCovers[coverId] = true;
    },
  },
});

export const { setShowedCover } = methodologySlice.actions;
export const methodologyReducer = methodologySlice.reducer;
